import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { checkFilterSmartView } from 'entities/SmartViews/lib/checkFilterSmartView'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversation } from 'entities/Conversation/api/types'
import { Conversation } from 'entities/Conversation/model/Conversation'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventSmartViewsConversationReassigned = () => {
  const entities = useEntitiesContext()
  const { smartViewsStore } = entities
  const handler = (data: IResponseConversation) => {
    const conversation = new Conversation(data, entities)

    smartViewsStore.itemsList.forEach((item) => {
      if (checkFilterSmartView(conversation.smartViewFilterParams, item.filters)) {
        runInAction(() => {
          item.setUnread(item.unread + conversation.concatUnread)
        })
      }
    })
  }

  useEffect(
    () => entities.websocket.on(WebsocketEvent.ConversationReassigned, handler),
    [smartViewsStore.itemsList]
  )
}
